<template>
  <div>
    <h1 class="admin-title">Users</h1>

    <div class="admin-container" style="position:relative;">
      <el-select class="list-filter" v-model="filterSetting" placeholder="Filter Users">
        <el-option key="all" label="All" value="all"></el-option>
        <el-option key="not_scored" label="Not Scored" value="not_scored"></el-option>
        <el-option key="scored" label="Scored" value="scored"></el-option>
        <el-option key="internalScore" label="Rating by WZA" value="internalScore"></el-option>
        <el-option key="rpScore" label="Rating by RP" value="rpScore"></el-option>
        <el-option key="bbScore" label="Rating by BB" value="bbScore"></el-option>
        <el-option key="nointernalScore" label="No Rating by WZA" value="nointernalScore"></el-option>
        <el-option key="norpScore" label="No Rating by RP" value="norpScore"></el-option>
        <el-option key="nobbScore" label="No Rating by BB" value="nobbScore"></el-option>
      </el-select>
      <data-tables
        v-loading="loading"
        :pagination-props="{ background: true, pageSizes: [5, 10, 20] }"
        :search-def="searchDef"
        :page-size="5"
        :table-props="tableProps"
        :data="users"
      >
        <el-table-column label="Name" sortable="custom">
          <template scope="scope">{{scope.row.firstName}} {{scope.row.lastName}}</template>
        </el-table-column>

        <el-table-column label="After Story" sortable="custom">
          <template scope="scope">
            <div
              @click="showStoryModal(scope.row.story,scope.row.afterStory)"
              class="story-preview"
            >BEFORE: {{scope.row.story}}</div>
            <div
              @click="showStoryModal(scope.row.story,scope.row.afterStory)"
              class="story-preview"
            >AFTER: {{scope.row.afterStory}}</div>
          </template>
        </el-table-column>

        <el-table-column label="Front">
          <template scope="scope">
            <div
              class="pic-wrapper"
              @click="showModal(scope.row.objectId, scope.row.frontPicture, scope.row.frontAfterPicture )"
            >
              <div
                class="pic-container"
                v-bind:style="{ backgroundImage: 'url(' + scope.row.frontPicture + ')' }"
              ></div>
              <div
                class="pic-container"
                v-bind:style="{ backgroundImage: 'url(' + scope.row.frontAfterPicture + ')' }"
              ></div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Back">
          <template scope="scope">
            <div
              class="pic-wrapper"
              @click="showModal(scope.row.objectId, scope.row.backPicture, scope.row.backAfterPicture )"
            >
              VIEW
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Side">
          <template scope="scope">
            <div
              class="pic-wrapper"
              @click="showModal(scope.row.objectId, scope.row.sidePicture, scope.row.sideAfterPicture )"
            >
              VIEW
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Front w/News">
          <template scope="scope">
            <div
              class="pic-wrapper"
              @click="showModal(scope.row.objectId, scope.row.frontNewsPicture, scope.row.frontNewsAfterPicture )"
            >
              VIEW
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Details">
          <template scope="scope">
            <div
              class="pic-wrapper"
              @click="()=>{detailUser=scope.row; showDetailUser = true;}"
            >
              VIEW
            </div>
          </template>
        </el-table-column>

        <el-table-column sortable="custom" prop="totalScore" key="totalScore" label="Rating" />
        <el-table-column min-width="160px">
          <template scope="scope">
            <el-row>
              <el-col :span="4">
                WZA
              </el-col>
              <el-col :span="20">
                <el-rate
                  @change="rateUser(scope.row.objectId, 'internalScore', scope.row.internalScore)"
                  :max="10"
                  v-model="scope.row.internalScore"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                RP
              </el-col>
              <el-col :span="20">
                <el-rate
                  @change="rateUser(scope.row.objectId, 'rpScore', scope.row.rpScore)"
                  :max="10"
                  v-model="scope.row.rpScore"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                BB
              </el-col>
              <el-col :span="20">
                <el-rate
                  @change="rateUser(scope.row.objectId, 'bbScore', scope.row.bbScore)"
                  :max="10"
                  v-model="scope.row.bbScore"
                />
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </data-tables>
    </div>
    <el-dialog title="Details" :visible.sync="showDetailUser">
      <template v-if="detailUser">
        <el-row>
          <el-col :span="6" style="text-align:left; font-weight: bold">Date of Birth</el-col>
          <el-col :span="18" style="text-align:left;">
            {{ detailUser.dobYear }}-{{ detailUser.dobMonth }}-{{ detailUser.dobDay }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            What is your fitness experience to this point?
          </el-col>
          <el-col :span="24">
            {{ detailUser.fitnessExperience }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            Do you train at a gym? If so, which?
          </el-col>
          <el-col :span="24">
            {{ detailUser.trainAtGym }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            What is your story? Tell us about you.
          </el-col>
          <el-col :span="24" style="text-align:left">
            <div v-html="detailUser.story"/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            What has motivated you to take on the WZA Transformation Challenge?
          </el-col>
          <el-col :span="24" style="text-align:left">
            <div v-html="detailUser.whyMove"/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            List your goals.
          </el-col>
          <el-col :span="24" style="text-align:left">
            {{ detailUser.goal }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            Which program do you wish to follow?
          </el-col>
          <el-col :span="24" style="text-align:left">
            {{ detailUser.programs }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:left; font-weight: bold">
            If WZA @ Home - What equipment do you have access to?
          </el-col>
          <el-col :span="24" style="text-align:left">
            {{ detailUser.equipments }}
          </el-col>
        </el-row>
      </template>
    </el-dialog>

    <el-dialog title :visible.sync="templateDialogVisible">
      <div v-if="currentUser">
        <div class="modal-image-wrapper">
          <div class="pic-container" v-bind:style="{ backgroundImage: 'url(' + beforePic + ')' }"></div>
          <div class="pic-container" v-bind:style="{ backgroundImage: 'url(' + afterPic + ')' }"></div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title :visible.sync="storyDialogVisible">
      <div>
        <p class="story-container">
          <strong>BEFORE:</strong>
          {{beforeStory}}
        </p>
        <p class="story-container">
          <strong>AFTER:</strong>
          {{afterStory}}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import converter from "json-2-csv";
import moment from "moment";
import { constants } from 'crypto';
const Json2csvParser = require("json2csv").Parser;
export default {
  name: "users",
  data() {
    return {
      detailUser: null,
      showDetailUser: false,
      loading: true,
      beforeStory: null,
      afterStory: null,
      beforePic: null,
      afterPic: null,
      filterSetting: "all",
      form: {
        password: null
      },
      savingPassword: false,
      sendingTemplate: false,
      template: {
        type: "healthy"
      },
      currentUser: null,
      currUserName: null,
      titles: [
        {
          prop: "id",
          label: "ID"
        },
        {
          prop: "firstName",
          label: "First Name"
        },
        {
          prop: "lastName",
          label: "Last Name"
        },
        {
          prop: "email",
          label: "Email"
        },
        {
          prop: "where",
          label: "Where"
        },
        {
          prop: "createdAt",
          label: "Registered"
        },
        {
          prop: "goal",
          label: "Goal",
          visible: false
        }
      ],
      tableProps: {
        defaultSort: {
          prop: "internalScore",
          order: "descending"
        }
      },
      filteredUsers: [],
      templateDialogVisible: false,
      storyDialogVisible: false,
      passwordDialogVisible: false,
      savingData: false,
      searchDef: {
        props: ["firstName", "lastName", "email", "where"],
        inputProps: {
          placeholder: "Search"
        }
      }
    };
  },
  watch: {
    // filterSetting: function() {
    //   if (this.filterSetting == "all") {
    //     this.filteredUsers = this.users;
    //   }

    //   if (this.filterSetting == "scored") {
    //     this.filteredUsers = [];
    //     for (var i = 0; i < this.users.length; i++) {
    //       if (this.users[i].rating) this.filteredUsers.push(this.users[i]);
    //     }
    //   }

    //   if (this.filterSetting == "not_scored") {
    //     this.filteredUsers = [];
    //     for (var i = 0; i < this.users.length; i++) {
    //       if (!this.users[i].rating) this.filteredUsers.push(this.users[i]);
    //     }
    //   }
    // }
  },
  computed: {
    users () {
      switch (this.filterSetting){
        case 'all': 
          return this.filteredUsers;
          break;
        case 'scored':
          return this.filteredUsers.filter(u => u.totalScore > 0);
          break;
        case 'not_scored':
          return this.filteredUsers.filter(u => !u.totalScore < 0);
          break;
        case 'internalScore':
          return this.filteredUsers.filter(u => (u.internalScore || 0) > 0);
          break;
        case 'rpScore':
          return this.filteredUsers.filter(u => (u.rpScore || 0) > 0);
          break;
        case 'bbScore':
          return this.filteredUsers.filter(u => (u.bbScore || 0) > 0);
          break;
        case 'nointernalScore':
          return this.filteredUsers.filter(u => !((u.internalScore || 0) > 0));
          break;
        case 'norpScore':
          return this.filteredUsers.filter(u => !((u.rpScore || 0) > 0));
          break;
        case 'nobbScore':
          return this.filteredUsers.filter(u => !((u.bbScore || 0) > 0));
          break;
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getUsers();
    });
  },
  methods: {
    rateUser(id, key, score) {
      Parse.Cloud.run(
        "rateUser", 
        { 
          id: id, 
          key: key,
          rating: score
        }
      ).then( response => {
        this.$message({
          type: "success",
          message: "Score saved"
        });
        this.getUsers();
      }).catch( err => {
        console.log(err);
      });
    },
    getUserById: function(id) {
      var found = _.find(this.users, function(u) {
        return u.objectId == id;
      });
      return found;
    },
    showModal: function(id, beforePic, afterPic) {
      this.currentUser = this.getUserById(id);
      this.beforePic = beforePic;
      this.afterPic = afterPic;
      this.templateDialogVisible = true;
    },
    showStoryModal: function(before, after) {
      var _this = this;
      _this.beforeStory = before;
      _this.afterStory = after;

      _this.storyDialogVisible = true;
    },
    csvExport: function() {
      var userList = [];
      for (var i = 0; i < this.users.length; i++) {
        userList.push({
          "First Name": this.users[i].firstName,
          "Last Name": this.users[i].lastName,
          Email: this.users[i].email,
          Gym: this.users[i].where,
          Registered: moment(this.users[i].createdAt).format("MM-DD-YY")
        });
      }
      const Json2csvParser = require("json2csv").Parser;
      const fields = ["First Name", "Last Name", "Email", "Gym", "Registered"];
      const opts = { fields };

      try {
        const parser = new Json2csvParser(opts);
        const csv = parser.parse(userList);
        console.log(csv);
        var csvContent = "data:text/csv;charset=utf-8," + csv;

        window.open(encodeURI(csvContent));
      } catch (err) {
        console.error(err);
      }
    },
    getUsers: function() {
      this.loading = true;
      Parse.Cloud.run("getAllUsers", { after: true }).then(results => {
        var tempUsers = [];
        this.filteredUsers = results.map(row => {
          let user = row.toJSON();
          return {
            ...user,
            totalScore: (user.internalScore || 0) + (user.rpScore || 0) + (user.bbScore || 0)
          }
        });
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    }
  }
};
</script>

<style>
.el-table .cell {
  font-size: 12px;
}
.export-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
}
.export-btn.lowercase {
  right: 120px;
}
.compliance-box {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 160px;
  margin-bottom: 30px;
}
.stat-box {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 130px;
}
.stat-box .title {
  font-family: "prohibition";
  font-size: 26px;
  margin-top: 0;
  padding: 10px 20px 0;
  width: 100%;
  text-align: left;
  display: inline-block;
  color: #999999;
  margin-bottom: 0;
}
.stat-box .value {
  color: #d70073;
  font-size: 68px;
  line-height: 68px;
  width: 100%;
  text-align: left;
  padding: 0 20px;
  font-family: "prohibition";
  display: inline-block;
  box-sizing: border-box;
}

.compliance-chart-container {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}
.compliance-row {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 10px 10px 5px 0;
}
.compliance-row div {
  flex-grow: 1;
}
.compliance-row div.week-title {
  width: 100px;
  text-align: center;
  font-family: prohibition;
  color: #999;
  font-size: 26px;
}

.checkin-marker i {
  background-color: #ccc;
  width: 15px;
  height: 15px;
  margin-top: 10px;
  border-radius: 100%;
  display: inline-block;
}
.checkin-marker.failed i {
  background-color: #eb4c60;
}
.checkin-marker.completed i {
  background-color: #76ce5a;
}

.modal-image-wrapper {
  width: 100%;
  height: 400px;
  margin: 0 auto;
}
.modal-image-wrapper .pic-container {
  width: 50%;
  height: 400px;
  float: left;
  background-color: #eee;
  background-size: cover;
  background-position: center;
  margin: 0 auto;
}

.story-preview {
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.story-preview:hover {
  background-color: #fefefe;
}
.pic-wrapper {
  width: 120px;
  height: 100px;
  margin: 0 auto;
}
.pic-container {
  width: 60px;
  height: 100px;
  float: left;
  background-color: #eee;
  background-size: cover;
  background-position: center;
  margin: 0 auto;
}
.list-filter {
  float: right;
  z-index: 300;
}
</style>